import JoditEditor from 'jodit-react';
import React, { useRef } from 'react';

export const TextEditor = ({ value, onChange }) => {
  const editor = useRef(null);

  const config = {
    readonly: false,
    placeholder: 'Start typing...',
    beautifyHTML: true, // Automatically beautifies HTML for better indentation
    enter: 'P', // Configures the Enter key to create a <p> tag
    toolbarAdaptive: false,
    useSearch: true, // Enable search in code mode
    allowResizeX: true,
    allowResizeY: true,
    showXPathInStatusbar: false, // Hides unnecessary info in the status bar
    askBeforePasteHTML: false,
    askBeforePasteFromWord: true,
    defaultActionOnPaste: 'insert_as_html',
    removeButtons: [
      'print',
      'font',
      'fontsize',
      'brush',
      'image',
      'file',
      'video',
      'about',
      'className',
      'paint',
      'lineHeight',
      'classSpan',
      'spellcheck',
      'copyformat',
      'ai-assistant',
      'ai-commands',
      'source',
    ],
    style: {
      'text-align': 'left',
    },
    defaultActionOnEnter: 'enter', // Use default behavior for new paragraphs
    events: {
      afterEnter: () => {
        console.log('Paragraph added after pressing Enter.');
      },
    },
    beforeCommand: (command) => {
      if (command === 'source') {
        const content = editor.current.getEditorValue();
        onChange(content);
      }
    },
  };

  const handleEditorBlur = (newContent) => {
    onChange(newContent); // Pass content to parent component
  };

  return (
    <div className="editor_our">
      <JoditEditor
        ref={editor}
        value={value}
        config={config}
        onBlur={handleEditorBlur} // Handle blur
      />
    </div>
  );
};
